module.exports = __webpack_public_path__ + "img/stock5.8dcef57a.png";